export default __webpack_public_path__ + "static/media/n_wdt_c_1.6cc198e7.mp3";